// arsivUcusFtl.js — ARŞİVDEN SİLİNEN iPad UÇUŞU FTL'DEN DE ÇIKAR — TEK KAYNAK (5 Eki 2026)
//
// 🔑 Serkan (5 Eki 2026): *"iPad'den gelmiş bir uçuş otomatik olarak FTL'e işleniyor ama uçuş tamamen silinince,
//    arşivden silinmiş uçuşun FTL'de kalması mantıksız. Silinsin ama şunu söylesin: FTL kayıtları da silinecek (ikinci
//    soru ekranı, warning vererek)"* · çok bacaklı görevde **a**: *"tabiki a"* — yalnız o bacak görevden çıkar, öteki
//    bacak kalır, FTL kalanla yeniden hesaplanır (sunucu); görevde uçuş bacağı kalmazsa görev iptal olur.
//    (*"yakında XML verisi işleyeceğiz, o zaman tek tek yüklenecek zaten bacaklar"*.)
// 🔴 Önce (31 Ağu 2026 kararı): arşiv silmesi FTL'e dokunmuyordu — silinen uçuşun görev ve uçuş süresi pilotların
//    toplamlarında kalıyordu.
// Bağ: arşiv uçuşu görevin bacağına `sectors[].plan_id` ve `plan_ids` ile yazılır (archive-flight). İkisi de okunur.
import { supabase } from '../supabaseClient';
import { rolOzeti } from './EkipRolleri';

const SECIM = 'id,customer_id,pilot_id,assignment_id,status,duty_date,sectors,plan_ids';

/** Silmeden ÖNCE ekrana: hangi görev iptal olur, hangisinden yalnız bacak çıkar.
 *  @returns {Promise<{ gorevler: { d, kalan, islem: 'iptal'|'bacak' }[], hata?: string }>} */
export async function ipadUcusFtlEtkisi(planId) {
  const id = String(planId || '');
  if (!id) return { gorevler: [] };
  const [a, b] = await Promise.all([
    supabase.from('crew_duties').select(SECIM).contains('plan_ids', [id]).neq('status', 'cancelled'),
    supabase.from('crew_duties').select(SECIM).contains('sectors', [{ plan_id: id }]).neq('status', 'cancelled'),
  ]);
  const hata = a.error || b.error;
  if (hata) return { gorevler: [], hata: `The crew duties of this flight could not be read — ${hata.message}` };
  const tekil = new Map();
  [...(a.data || []), ...(b.data || [])].forEach(d => tekil.set(d.id, d));
  const gorevler = [...tekil.values()].map(d => {
    const kalan = (d.sectors || []).filter(x => String(x?.plan_id || '') !== id);
    return { d, kalan, islem: kalan.some(x => !x?.deadhead) ? 'bacak' : 'iptal' };
  });
  return { gorevler };
}

/** Etkiyi uygular — iz ÖNCE, her yazma dönen satırla. @returns {Promise<{ tamam, iptal, bacak, hata?, kismen? }>} */
export async function ipadUcusuFtldenCikar({ planId, gerekce, kullaniciId = null, etki }) {
  const id = String(planId || '');
  const sonuc = { tamam: false, iptal: 0, bacak: 0 };
  const why = `Flight deleted from ARCHIVED FLTS — removed from FTL: ${String(gerekce || '').trim()}`;
  const gorevler = etki?.gorevler || [];
  if (!gorevler.length) return { ...sonuc, tamam: true };
  const iz = gorevler.map(({ d, kalan, islem }) => ({
    duty_id: d.id, customer_id: d.customer_id, pilot_id: d.pilot_id, assignment_id: d.assignment_id || null,
    edit_type: islem === 'iptal' ? 'CANCEL' : 'EDIT', field_name: islem === 'iptal' ? 'status' : 'sectors',
    old_value: islem === 'iptal' ? d.status : rolOzeti(d.sectors), new_value: islem === 'iptal' ? 'cancelled' : rolOzeti(kalan),
    reason: why, edited_by: kullaniciId,
  }));
  const { error: izErr } = await supabase.from('ftl_duty_edits').insert(iz);
  if (izErr) return { ...sonuc, hata: `Audit write failed — ${izErr.message}. FTL was not changed.` };
  for (const { d, kalan, islem } of gorevler) {
    const patch = islem === 'iptal' ? { status: 'cancelled' }
      : { sectors: kalan, plan_ids: (d.plan_ids || []).filter(p => String(p) !== id) };
    const { data, error } = await supabase.from('crew_duties').update(patch).eq('id', d.id).select('id');
    if (error || (data || []).length !== 1) {
      return { ...sonuc, kismen: sonuc.iptal + sonuc.bacak > 0,
               hata: `FTL not fully updated — duty ${d.duty_date || d.id}: ${error?.message || 'no row returned (permission?)'}` };
    }
    if (islem === 'iptal') sonuc.iptal += 1; else sonuc.bacak += 1;
  }
  return { ...sonuc, tamam: true };
}
